/**
 * 日本/韩国/台湾/法国/德国/马来西亚 兜底页面
 */
import React from "react"
import "./index.less"
import { StockHeader } from "../../shared/stock_header"
import { quotedata } from "../../shared/quotedata"
import { StockInfoTabs } from "../../shared/stock_info_tabs"
import { ChartTab } from "../../shared/chart_tab"
import { OpenInApp } from "../../shared/open_in_app"
import { GoTop } from "../../shared/go_top"
import { CommonFooter } from "../../shared/common_footer"
import { StockFixedFooter } from "../../shared/stock_fixed_footer"
import { AdvertiseTop } from "../../shared/advertise_top"
import { DefaultBasicInfo } from "./basic_info"
import { getPageType, getStockSubType, PageType, StockSubType } from "../../shared/pagetype"
import { Observer } from "mobx-react-lite"
import { getMarketSource } from "../../../modules/quote/web"

export function Page_Overseas_Default(props: { quotedata: quotedata }) {
  let pagetype = getPageType()
  let stocksubtype = getStockSubType()
  let _market = getMarketSource(props.quotedata.quotecode)

  return (
    <>
      <AdvertiseTop />
      <div className="stock-detail">
        <WrapStockHeader quotedata={props.quotedata} pagetype={pagetype} />
        <DefaultBasicInfo />
        <WrapCharts quotedata={props.quotedata} pagetype={pagetype} stocksubtype={stocksubtype} />
        <StockInfoTabs showTabs={["股吧"]} quotedata={props.quotedata} pagetype={pagetype} _market={_market}/>
      </div>
      <OpenInApp quotedata={props.quotedata} type={"page"} />
      <GoTop />
      <CommonFooter quotedata={props.quotedata} hide_fix_bottom={false} />
      {/* <StockFixedFooter quotedata={props.quotedata} pagetype={pagetype} /> */}
    </>
  )
}

function WrapStockHeader(props: { quotedata: quotedata ,pagetype: PageType}) {
  return <Observer>{() => <StockHeader quotedata={props.quotedata} detail_data={{}} pagetype={props.pagetype}/>}</Observer>
}

function WrapCharts(props: { quotedata: quotedata; pagetype: PageType; stocksubtype: StockSubType }) {
  return <Observer>{() => <>{<ChartTab quotedata={props.quotedata} pagetype={props.pagetype}  stocksubtype={props.stocksubtype} />}</>}</Observer>
}
